export const PASSWORD_RESET = 'passwordReset/PASSWORD_RESET';
export const PASSWORD_RESET_FAILURE = 'passwordReset/PASSWORD_RESET_FAILURE';
export const PASSWORD_RESET_SUCCESS = 'passwordReset/PASSWORD_RESET_SUCCESS';
export const RESET_STATE = 'passwordReset/RESET_STATE';
